module.exports = __webpack_public_path__ + "img/item-5(1920).2f5f7529.jpg";